import MainBlockLayout from '../../components/MainBlockLayout';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import React from "react";
import { Trans, useTranslation } from 'react-i18next';

import innaHryhorovych from '../../images/ourTeam/dropbox/Inna_Hryhorovych.jpg';
import orysyaNovetska from '../../images/ourTeam/dropbox/Orysya_Novetska.jpg';
import mykolaKoval from '../../images/ourTeam/dropbox/Mykola_Koval.jpg';
import nadiaVorokhib from '../../images/ourTeam/dropbox/Nadia_Vorokhib.jpg';
import tejiBarnets from '../../images/ourTeam/dropbox/Teji_Barnets.jpg';
import nataliaKaplun from '../../images/ourTeam/dropbox/Natalia_Kaplun.jpg';
import annaDezyk from '../../images/ourTeam/dropbox/Anna_Dezyk.jpg';
import volodymyrDyrda from '../../images/ourTeam/dropbox/Volodymyr_Dyrda.jpg';
import lyudmylaKavchak from '../../images/ourTeam/dropbox/Lyudmyla_Kavchak.jpg';
import tetianaVitvitska from '../../images/ourTeam/dropbox/Tetiana_Vitvitska.jpg';
import annaVasiukhno from '../../images/ourTeam/dropbox/Anna_Vasiukhno.jpg';
import victoriaHuk from '../../images/ourTeam/dropbox/Victoria_Huk.jpg';
import olesyaHevchuk from '../../images/ourTeam/dropbox/Olesya_Hevchuk.jpg';
import tetianaHumberstone from '../../images/ourTeam/dropbox/Tetiana_Humberstone.jpg';
import yuliaMarusyk from '../../images/ourTeam/dropbox/Yulia_Marusyk.jpg';
import katerynaMarkovska from '../../images/ourTeam/dropbox/Kateryna_Markovska.jpg';
import oleksandraOnyshkevych from '../../images/ourTeam/dropbox/Oleksandra_Onyshkevych.jpg';
import irynaDonenko from '../../images/ourTeam/dropbox/Iryna_Donenko.jpg';
import olenaSvitlyk from '../../images/ourTeam/dropbox/Olena_Svitlyk.jpg';

const BOARD_OF_GOVERNORS = [
    { key: 'inna-hryhorovych', photo: innaHryhorovych },
    { key: 'orysya-novetska', photo: orysyaNovetska },
    { key: 'mykola-koval', photo: mykolaKoval },
    { key: 'nadia-vorokhib', photo: nadiaVorokhib },
    { key: 'teji-barns', photo: tejiBarnets },
    { key: 'natalia-kaplun', photo: nataliaKaplun },
    { key: 'hania-dezyk', photo: annaDezyk },
];

const LEADERSHIP_TEAM = [
    { key: 'lyudmyla-kavchak', photo: lyudmylaKavchak },
    { key: 'tetiana-vitvitska', photo: tetianaVitvitska },
    { key: 'anna-vasiukhno', photo: annaVasiukhno },
    { key: 'olesya-hevchuk', photo: olesyaHevchuk },
    { key: 'victoria-huk', photo: victoriaHuk },
    { key: 'tetiana-humberstone', photo: tetianaHumberstone },
    { key: 'yulia-marusyk', photo: yuliaMarusyk },
    { key: 'kateryna-markovska', photo: katerynaMarkovska },
    { key: 'oleksandra-onyshkevych', photo: oleksandraOnyshkevych },
    { key: 'iuliia-ciobanu', photo: null },
    { key: 'iryna-donenko', photo: irynaDonenko },
    { key: 'olena-svitlyk', photo: olenaSvitlyk },
    { key: 'volodymyr-dyrda', photo: volodymyrDyrda },
];

function TeamMemberCard({ memberKey, photo }) {
    const { t } = useTranslation('coreTeam');

    return (
        <Card className="core-team-card h-100">
            <Card.Body className="text-center d-flex flex-column align-items-center">
                {photo ? (
                    <img
                        src={photo}
                        alt={t(`member.${memberKey}.name`)}
                        className="core-team-photo"
                        loading="lazy"
                        decoding="async"
                    />
                ) : (
                    <div className="core-team-photo core-team-photo-placeholder">
                        <span>{t(`member.${memberKey}.initials`)}</span>
                    </div>
                )}
                <Card.Title className="core-team-name mt-3">
                    <Trans ns="coreTeam" i18nKey={`member.${memberKey}.name`} />
                </Card.Title>
                <Card.Text className="core-team-role mb-0">
                    <Trans ns="coreTeam" i18nKey={`member.${memberKey}.role`} />
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

function MainBlock() {
    return (
        <div className="core-team-page px-3 px-sm-4 px-md-5">
            <div className="core-team-hero text-center">
                <h1 className="core-team-main-title">
                    <Trans ns="coreTeam" i18nKey="team.mainTitle" />
                </h1>
                <p className="core-team-subtitle mb-0">
                    <Trans ns="coreTeam" i18nKey="team.subtitle" />
                </p>
            </div>

            <section className="core-team-section">
                <h2 className="core-team-section-title">
                    <Trans ns="coreTeam" i18nKey="team.boardTitle" />
                </h2>
                <Row className="g-4">
                    {BOARD_OF_GOVERNORS.map(({ key, photo }) => (
                        <Col key={key} xs={12} sm={6} lg={4} xl={3}>
                            <TeamMemberCard memberKey={key} photo={photo} />
                        </Col>
                    ))}
                </Row>
            </section>

            <section className="core-team-section">
                <h2 className="core-team-section-title">
                    <Trans ns="coreTeam" i18nKey="team.leadershipTitle" />
                </h2>
                <Row className="g-4">
                    {LEADERSHIP_TEAM.map(({ key, photo }) => (
                        <Col key={key} xs={12} sm={6} lg={4} xl={3}>
                            <TeamMemberCard memberKey={key} photo={photo} />
                        </Col>
                    ))}
                </Row>
            </section>
        </div>
    );
}

export default MainBlockLayout(MainBlock);